import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { 
  FaMapMarkerAlt, 
  FaEnvelope, 
  FaPhone, 
  FaClock, 
  FaPaperPlane,
  FaUser,
  FaRegEnvelope,
  FaRegCommentDots
} from "react-icons/fa";

import NavBar from "../components/Nav";
import Footer from "../components/footer";
import ScrollTop from "../components/Scrolltop";
import Whatsapp from "../components/Whatsapp";

import "./Contactus.css";

const ContactUs = () => {

      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone_number: "",
    subject: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, phone_number } = formData;
    if (!name || !email || !phone_number) {
      toast.warn("Please fill in all required fields.");
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post(
        "https://api.easytaxexperts.com/contactusformdata",
        formData
      );
      toast.success(response.data.message);
      setSubmitted(true);
      setFormData({
        name: "",
        email: "",
        phone_number: "",
        subject: "",
        message: "",
      });
    } catch (error) {
      console.error("Error submitting contact form:", error);
      toast.error("Error submitting contact form. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const contactInfo = [
    {
      icon: <FaMapMarkerAlt />,
      title: "Our Location",
      content: "16192 Coastal Highway Lewis, DE 19958",
     
    },
    {
      icon: <FaEnvelope />,
      title: "Email Us",
      content: "info@easytaxexperts.com",
      description: "Send us an email anytime"
    },
    {
      icon: <FaPhone />,
      title: "Call Us",
      content: "+1 (945)-358-4442",
      description: "Mon to Fri from 10am to 6pm"
    }
  ];

  return (
    <div className="contact-alt-page">
      <NavBar />

      {/* Minimal Hero */}
      <div className="contact-alt-hero">
        <div className="contact-alt-hero-content">
          <h1 className="contact-alt-hero-title">Contact Us</h1>
          <p className="contact-alt-hero-subtitle">
            Ready to simplify your taxes? Let's start the conversation.
          </p>
        </div>
      </div>

      <div className="contact-alt-container">
        {/* Contact Cards Section */}
        <div className="contact-cards-section">
          <div className="contact-cards-grid">
            {contactInfo.map((item, index) => (
              <div key={index} className="contact-alt-card">
                <div className="contact-alt-icon">
                  {item.icon}
                </div>
                <h3 className="contact-alt-card-title">{item.title}</h3>
                <p className="contact-alt-card-content">{item.content}</p>
                <p className="contact-alt-card-description">{item.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Main Content */}
        <div className="contact-alt-main">
          <div className="contact-alt-content">
            {/* Left: Form */}
            <div className="contact-alt-form-wrapper">
              <div className="form-alt-header">
                <h2>Get In Touch</h2>
                <p>Fill out the form and our team will get back to you within 24 hours</p>
              </div>

              {submitted ? (
                <div className="success-alt-message">
                  <div className="success-alt-icon">🎉</div>
                  <h3>Message Sent Successfully!</h3>
                  <p>Thank you for reaching out. We've received your message and will contact you shortly.</p>
                  <button 
                    className="back-to-form-alt-btn"
                    onClick={() => setSubmitted(false)}
                  >
                    Send New Message
                  </button>
                </div>
              ) : (
<form className="contact-alt-form" onSubmit={handleSubmit}>
  <div className="form-alt-group">
    <ContactAltInput
      label="Full Name"
      name="name"
      value={formData.name}
      onChange={handleChange}
      placeholder="John Doe"
      required
      icon={<FaUser className="input-icon" />}
    />
  </div>

  <div className="form-alt-group">
    <ContactAltInput
      label="Email Address"
      name="email"
      type="email"
      value={formData.email}
      onChange={handleChange}
      placeholder="john@example.com"
      required
      icon={<FaRegEnvelope className="input-icon" />}
    />
  </div>

  <div className="form-alt-group">
    <ContactAltInput
      label="Phone Number"
      name="phone_number"
      value={formData.phone_number}
      onChange={handleChange}
      placeholder="+1 (987)-654-3210"
      required
      icon={<FaPhone className="input-icon" />}
    />
  </div>

  <div className="form-alt-group">
    <ContactAltInput
      label="Subject"
      name="subject"
      value={formData.subject}
      onChange={handleChange}
      placeholder="What's this regarding?"
      icon={<FaRegEnvelope className="input-icon" />} 
    />
  </div>

  <div className="form-alt-group">
    <ContactAltTextarea
      label="Your Message"
      name="message"
      value={formData.message}
      onChange={handleChange}
      rows={6}
      placeholder="Tell us how we can help you with your tax needs..."
      icon={<FaRegCommentDots className="input-icon textarea-icon" />}
    />
  </div>

  {/* Add this container to center the button */}
  <div className="submit-button-container">
    <button type="submit" className="submit-alt-btn" disabled={isLoading}>
      {isLoading ? (
        <div className="loading-alt-spinner"></div>
      ) : (
        <>
          <FaPaperPlane className="btn-alt-icon" />
          Send Message
        </>
      )}
    </button>
  </div>
</form>
              )}
            </div>

            {/* Right: Map & Info */}
            <div className="contact-alt-sidebar">
              <div className="sidebar-section">
                <h3>Office Location</h3>
                <div className="map-alt-container">
                  <iframe
                    title="office-map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3175.0000000000005!2d-75.16200000000001!3d38.757000000000005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c7700000000001%3A0x0000000000000000!2s16192%20Coastal%20Highway%2C%20Lewes%2C%20DE%2019958!5e0!3m2!1sen!2s!4v0000000000000!5m2!1sen!2s"
                    width="100%"
                    height="300"
                    style={{ border: 0, borderRadius: "12px" }}
                    allowFullScreen=""
                    loading="lazy"
                  ></iframe>
                </div>
              </div>

              <div className="sidebar-section">
                <h3>Business Hours</h3>
                <div className="hours-info">
                  <div className="hours-item">
                    <span className="hours-days">Monday - Friday</span>
                    <span className="hours-time">10:00 AM - 6:00 PM</span>
                  </div>
                  <div className="hours-item">
                    <span className="hours-days">Saturday</span>
                    <span className="hours-time">10:00 AM - 2:00 PM</span>
                  </div>
                  <div className="hours-item">
                    <span className="hours-days">Sunday</span>
                    <span className="hours-time closed">Closed</span>
                  </div>
                </div>
              </div>

              
            </div>
          </div>
        </div>
      </div>

      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

const ContactAltInput = ({ label, name, value, onChange, type = "text", placeholder, required, icon }) => (
  <div className="contact-alt-field">
    <label htmlFor={name} className="contact-alt-label">{label}</label>
    <div className="input-alt-wrapper">
      {icon}
      <input 
        type={type} 
        id={name} 
        name={name} 
        value={value} 
        onChange={onChange} 
        placeholder={placeholder}
        required={required}
        className="contact-alt-input"
      />
    </div>
  </div>
);

const ContactAltTextarea = ({ label, name, value, onChange, rows = 4, placeholder, required, icon }) => (
  <div className="contact-alt-field">
    <label htmlFor={name} className="contact-alt-label">{label}</label>
    <div className="textarea-alt-wrapper">
      {icon}
      <textarea 
        id={name} 
        name={name} 
        value={value} 
        onChange={onChange} 
        rows={rows} 
        placeholder={placeholder}
        required={required}
        className="contact-alt-textarea"
      ></textarea>
    </div>
  </div>
);

export default ContactUs;